PLAN_SKU_BULK_GIFT_EVENTS_PLUS